import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';

export default function Content() {
  // const data = useSelector((state) => state.data.data);
  // const stageWidth = useSelector((state) => state.resize.width);
  // const stageHeight = useSelector((state) => state.resize.height);

  return <div />;
}
